import { connect } from 'react-redux';
import idx from 'idx';
import partial from 'lodash/partial';
import { bindActionCreators } from 'redux';
import { updateSettings } from 'focus_groups/ducks/view_state';
import ToggleGroupButton from 'focus_groups/components/toggle_group_button';

export function mapStateToProps(state) {
  const { status } = idx(state, _ => _.project.focusGroups.viewState.currentGroup) || {};

  return {
    isOpen: status === 'open',
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    closeGroup: partial(updateSettings, { status: 'closed' }),
    openGroup: partial(updateSettings, { status: 'open' }),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ToggleGroupButton);



// WEBPACK FOOTER //
// ./focus_groups/containers/toggle_group_button.js